import { Typography } from '@material-ui/core';
import { get } from 'lodash';
import React from 'react';
import { cellDataFormatter } from 'util/TableDataFormatters';

const ReadOnlyCell = React.memo(
  ({ row, column, rowState, handleRowChange, color }) => {
    const dataType = get(column, 'columnContentType.dataType', 0);

    React.useEffect(() => {
      handleRowChange(row.id, {
        [column.key]:
          (rowState || {})[column.key] || (row[column.key] || {}).value || null,
      });
    }, [row]);

    return (
      <Typography
        style={{
          color:
            (row[column.key] || rowState[column.key] || {}).color || '#000000',
          fontSize: '1rem',
          wordWrap: 'break-word',
          whiteSpace: 'pre-wrap',
          padding: '6px 0px 6px',
          fontWeight: 500,
        }}
        noWrap
      >
        {
          // TODO Apply lodash nesting
          (get(cellDataFormatter, dataType) || ((text) => text))(
            rowState[column.key] || (row[column.key] || {}).value
          )
        }
      </Typography>
    );
  },
  (prevProps, currentProps) =>
    (prevProps.rowState || {})[(prevProps.column || {}).key] ===
      (currentProps.rowState || {})[(currentProps.column || {}).key] &&
    prevProps.delected === currentProps.selected
);

export default ReadOnlyCell;
